import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const CopyLink = ({
  width = 24,
  height = 24,
  className,
  color = "primary",
  decorative = false,
  ariaLabel = "Copy link",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="m12.7 12.7.7.7a3.6 3.6 0 0 0 1.2-2.8 3.6 3.6 0 0 0-1.2-2.8L9.9 4.2a4.2 4.2 0 0 0-5.7 0 4.2 4.2 0 0 0 0 5.7l2.9 2.8.7-.7-2.9-2.8a3.2 3.2 0 0 1 0-4.3 3.2 3.2 0 0 1 4.3 0l3.5 3.6a2.7 2.7 0 0 1 .9 2.1 2.9 2.9 0 0 1-.9 2.1m7.1 1.4a4.2 4.2 0 0 1 0 5.7 3.9 3.9 0 0 1-2.9 1.1 3.8 3.8 0 0 1-2.8-1.1l-3.5-3.6a3.6 3.6 0 0 1-1.2-2.8 3.6 3.6 0 0 1 1.2-2.8l.7.7a2.9 2.9 0 0 0-.9 2.1 2.7 2.7 0 0 0 .9 2.1l3.5 3.6a3.2 3.2 0 0 0 4.3 0 3.2 3.2 0 0 0 0-4.3L16.2 12l.7-.7z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
